import { render, staticRenderFns } from "./itemtrans.vue?vue&type=template&id=d9778b48"
import script from "./itemtrans.vue?vue&type=script&lang=js"
export * from "./itemtrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports